export default __webpack_public_path__ + "static/notebooks-watershed-e6aaa15d852002a8559e4180fed609a0.png";